// useInterfaceResolution.ts

import { DeviceVariantType } from '@unifyapps/defs/types/deviceVariant';
import { NavigationResolution } from '@unifyapps/defs/types/interface';
import { useEffect, useState } from 'react';
import { InterfaceModes } from '../stores/InterfaceStore';
import { getResolutionByDevice, getBreakpoint } from '../utils/getResolutionByDevice';

export const useInterfaceResolution = (
  element: HTMLDivElement | null,
  device: DeviceVariantType,
  mode?: InterfaceModes,
) => {
  const [resolution, setResolution] = useState<NavigationResolution>(() =>
    getResolutionByDevice(device, mode),
  );

  useEffect(() => {
    if (!element) return;

    const handleResize = (entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        const newBreakpoint = getBreakpoint(entry.contentRect.width, mode);
        setResolution((currentBreakpoint) => {
          if (currentBreakpoint !== newBreakpoint) {
            return newBreakpoint;
          }
          return currentBreakpoint;
        });
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(element);

    // Set initial resolution based on element width
    setResolution(getBreakpoint(element.offsetWidth, mode));

    return () => {
      resizeObserver.disconnect();
    };
  }, [element, mode]);

  return { resolution };
};
